import React, { Component } from 'react';
import { BackButton } from '../button/back-button/BackButton';

class PageHeaderWithBackButton extends Component {
    render() {
        return (
            <div className="page-header-with-buttons">
                <span
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'baseline'
                    }}
                >
                    <div className="page-header">{this.props.header}</div>
                    {this.props.subheader && (
                        <div className="page-sub-header">
                            {this.props.subheader}
                        </div>
                    )}
                </span>
                <BackButton />
            </div>
        );
    }
}

export default PageHeaderWithBackButton;
